import { render, staticRenderFns } from "./b43.vue?vue&type=template&id=72dc05bc&scoped=true"
import script from "./b43.vue?vue&type=script&lang=js"
export * from "./b43.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc05bc",
  null
  
)

export default component.exports